"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var get_1 = tslib_1.__importDefault(require("lodash/get"));
var constants = tslib_1.__importStar(require("@biw/contests-constants"));
var get_progress_status_treatment_1 = tslib_1.__importDefault(require("./utils/get-progress-status-treatment"));
var resultCodes = tslib_1.__importStar(require("./result-codes"));
var finalStatus = tslib_1.__importStar(require("./final-status"));
exports.GOAL_LABEL_DEFAULTS = {
    amount: 0,
    currencyCode: '',
    labelPosition: '',
    labelText: '',
    labelType: 'decimal',
    precision: 0,
    rounding: ''
};
var EMPTY_ARRAY = Object.freeze([]);
var EMPTY_OBJ = Object.freeze({});
var calculatePercent = function (count, total) {
    var percent = Math.round((count / total) * 100);
    return isNaN(percent) ? 0 : percent;
};
function buildGoalObject(activity) {
    return {
        payoutTierId: activity.activityId,
        name: activity.name || '',
        description: activity.description || '',
        goalAchieveAmount: activity.challenge.goal || 0,
        goalAwardAmount: 0,
        minQualifier: null,
        maxPoints: null,
        goalCalculationValue: null
    };
}
var ComputedProgress = /** @class */ (function () {
    function ComputedProgress(program, progress) {
        this.__state = progress || EMPTY_OBJ;
        this.program = program || EMPTY_OBJ;
        this.__proxyRef = {};
        this.__setCache = this.__setCache.bind(this);
    }
    /**
     * Sets the proxy cache value for a given key. Primarily used as a hook for testing.
     * @param key
     * @param value
     */
    ComputedProgress.prototype.__setCache = function (key, value) {
        this.__proxyRef[key] = value;
    };
    Object.defineProperty(ComputedProgress.prototype, "baseGoalLabel", {
        get: function () {
            return tslib_1.__assign({}, exports.GOAL_LABEL_DEFAULTS, get_1.default(this.__state, 'goal.goalLabel') || EMPTY_OBJ, { precision: this.program.goalPrecision || exports.GOAL_LABEL_DEFAULTS.precision, rounding: this.program.goalRoundingMethod || exports.GOAL_LABEL_DEFAULTS.rounding });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "bonusLabel", {
        get: function () {
            return tslib_1.__assign({}, exports.GOAL_LABEL_DEFAULTS, get_1.default(this.__state, 'goal.bonusPayout.label') || EMPTY_OBJ, { precision: this.program.bonusPrecision || exports.GOAL_LABEL_DEFAULTS.precision, rounding: this.program.bonusRoundingMethod || exports.GOAL_LABEL_DEFAULTS.rounding });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "minimumQualifierLabel", {
        get: function () {
            return tslib_1.__assign({}, exports.GOAL_LABEL_DEFAULTS, get_1.default(this.__state, 'goal.mqLabel') || EMPTY_OBJ, { precision: this.program.mqPrecision || exports.GOAL_LABEL_DEFAULTS.precision, rounding: this.program.mqRoundingMethod || exports.GOAL_LABEL_DEFAULTS.rounding });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "calculationLabel", {
        get: function () {
            return get_1.default(this.__state, 'goal.calculationLabel') || '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "goalProgress", {
        get: function () {
            var progressData = get_1.default(this.__state, 'progress.0') || EMPTY_OBJ;
            var daysFromProgramStart = this.program.totalProgramDays - this.program.daysToProgramEndDate;
            var throughProgramPercent = Math.round((daysFromProgramStart) / this.program.totalProgramDays * 10000) / 100;
            return {
                dataThrough: progressData.dataThrough || 0,
                dateThroughPercentage: throughProgramPercent || 0,
                isMinQualifierAchieved: progressData.isMinQualifierAchieved || false,
                resultsToDate: progressData.resultsToDate || 0,
                resultsToDateCalculationValue: progressData.resultsToDateCalculationValue || 0,
                currentGoalValue: progressData.completionCount || 0,
                // percentage for standard calculations
                progressPercentage: progressData.percentComplete || 0,
                // percentage for non-standard calculations
                onTrackPercentage: progressData.onTrackPercentage || 0,
                toAchieveCalculationValue: progressData.toAchieveCalculationValue || 0,
                toAchieve: progressData.toAchieve || 0,
                currentMQValue: progressData.currentMQValue || 0,
                currentBonusValue: progressData.currentBonusValue || 0,
                earnedToDate: progressData.earnedToDate || 0,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "programCalculationType", {
        get: function () {
            return get_1.default(this.__state, 'goal.programCalculationType') || null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "isStandard", {
        get: function () {
            // return this.__proxyRef.programCalculationType === constants.CALC_STANDARD;
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "isReduction", {
        get: function () {
            // return this.__proxyRef.programCalculationType === constants.CALC_REDUCTION;
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "isAverage", {
        get: function () {
            // return this.__proxyRef.programCalculationType === constants.CALC_AVERAGE;
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "baseValue", {
        get: function () {
            return get_1.default(this.__state, 'goal.baseValue') || EMPTY_OBJ;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "baseLevel", {
        get: function () {
            return get_1.default(this.__state, 'goal.baseLevel') || EMPTY_OBJ;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "bonusPayout", {
        get: function () {
            return get_1.default(this.__state, 'goal.bonusPayout') || EMPTY_OBJ;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "finalResult", {
        get: function () {
            return get_1.default(this.__state, 'finalResult') || EMPTY_OBJ;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "hasMinimumQualifier", {
        get: function () {
            return !!get_1.default(this.__state, 'goal.isMinimumQualifierEnabled');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "hasAchievedGoal", {
        get: function () {
            return !!get_1.default(this.__state, 'finalResult.acheivedGoal', false);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "hasAchievedMQ", {
        get: function () {
            return !!get_1.default(this.__state, 'finalResult.isMQAchieved', false);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "goalPayoutTierType", {
        get: function () {
            return get_1.default(this.__state, 'goal.goalPayoutTierType') || '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "goalSelectionCount", {
        get: function () {
            var countData = get_1.default(this.__state, 'goal.selectionCount') || EMPTY_OBJ;
            return {
                total: countData.paxCount || 0,
                count: countData.goalSelectedCount || 0,
                percent: calculatePercent(countData.goalSelectedCount, countData.paxCount)
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "progressCount", {
        get: function () {
            var countData = get_1.default(this.__state, 'goal.participantOnTrack') || EMPTY_OBJ;
            return {
                total: countData.paxCount || 0,
                count: countData.onTrackCount || 0,
                percent: calculatePercent(countData.onTrackCount, countData.paxCount)
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "finalResultsCount", {
        get: function () {
            var countData = get_1.default(this.__state, 'goal.participantOnTrack') || EMPTY_OBJ;
            var resultData = get_1.default(this.__state, 'finalResult') || EMPTY_OBJ;
            return {
                total: countData.paxCount || 0,
                count: resultData.totalNumberofPaxWhoAchievedGoal || 0,
                percent: calculatePercent(resultData.totalNumberofPaxWhoAchievedGoal, countData.paxCount)
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "goalLevels", {
        get: function () {
            return (this.__state.activities || EMPTY_ARRAY).map(buildGoalObject);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "goalSelection", {
        /**
         * Alias for `selectedGoal`
         */
        get: function () {
            return this.__proxyRef.selectedGoal;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "selectedGoal", {
        /**
         * selectedGoal is a front end interpritation of an activity and the reward
         */
        get: function () {
            var _a = tslib_1.__read(this.__proxyRef.goalLevels, 1), selectedGoal = _a[0];
            if (!selectedGoal) {
                return null;
            }
            return selectedGoal;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "isFixedRatePayout", {
        get: function () {
            return this.__proxyRef.goalPayoutTierType === constants.PT__FIXED_RATE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "isBonusEnabled", {
        get: function () {
            return get_1.default(this.__state, 'goal.isBonusEnabled') || false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "isMinimumQualifierAchieved", {
        get: function () {
            return !!this.__proxyRef.goalProgress.isMinQualifierAchieved;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "throughProgram", {
        get: function () {
            return {
                date: this.__proxyRef.goalProgress.dataThrough || Date.now(),
                percentage: this.program.isFinalResults ? 1 : Number(this.__proxyRef.goalProgress.dateThroughPercentage || 0) / 100
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "lastDayOfCurrentStage", {
        get: function () {
            return this.program.programHasStarted ? this.program.endDate : this.program.startDate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "goalBaseLine", {
        get: function () {
            // TODO: Figure out what do?
            return null;
            // if ( !this.__state.goal || !get( this.__state, 'goal.isBaseLineRequired' ) ) {
            //     return null;
            // }
            // const { goalBaseCalculationValue } = this.__proxyRef.baseValue;
            // const canCalculateProgress = !!this.__proxyRef.calculationLabel && !!goalBaseCalculationValue;
            // return {
            //     headerCode: 'progress.goalHeader',
            //     calculationLabel: this.__proxyRef.calculationLabel,
            //     canCalculateProgress,
            //     goalLabelProps: {
            //         ...this.__proxyRef.baseGoalLabel,
            //         amount: this.__proxyRef.baseValue.goalBaseValue || 0
            //     },
            //     calculationLabelProps: canCalculateProgress ? {
            //         ...this.__proxyRef.baseGoalLabel,
            //         amount: goalBaseCalculationValue
            //     } : null
            // };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "goalOverview", {
        get: function () {
            if (Object.keys(this.__state).length === 0 || !this.__proxyRef.goalSelection) {
                return null;
            }
            var _a = this.__proxyRef.goalSelection, goalCalculationValue = _a.goalCalculationValue, goalAchieveAmount = _a.goalAchieveAmount;
            var canCalculateProgress = !!this.__proxyRef.calculationLabel && !!goalCalculationValue && !this.program.isAverageCalculationType;
            return {
                headerCode: 'progress.goalHeader',
                calculationLabel: this.__proxyRef.calculationLabel,
                canCalculateProgress: canCalculateProgress,
                goalLabelProps: tslib_1.__assign({}, this.__proxyRef.baseGoalLabel, { amount: goalAchieveAmount || 0 }),
                calculationLabelProps: canCalculateProgress ? tslib_1.__assign({}, this.__proxyRef.baseGoalLabel, { amount: goalCalculationValue }) : null
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "resultsToDate", {
        get: function () {
            // TODO: Figure out what do?
            return null;
            // if ( !this.__state.goal ) {
            //     return null;
            // }
            // const perPeriodAmount = this.__proxyRef.goalProgress.resultsToDateCalculationValue || 0;
            // const canCalculateProgress = !!this.__proxyRef.calculationLabel && !!perPeriodAmount;
            // return {
            //     headerCode: this.program.isFinalResults ? 'progress.finalResultsHeaders' : 'progress.resultToDateHeader',
            //     calculationLabel: this.__proxyRef.calculationLabel,
            //     canCalculateProgress,
            //     goalLabelProps: {
            //         ...this.__proxyRef.baseGoalLabel,
            //         amount: this.__proxyRef.goalProgress.resultsToDate || 0
            //     },
            //     calculationLabelProps: canCalculateProgress ? {
            //         ...this.__proxyRef.baseGoalLabel,
            //         amount: perPeriodAmount
            //     } : null
            // };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "resultsToAchieve", {
        get: function () {
            var progressPercentage = this.__proxyRef.goalProgress.progressPercentage;
            if (Object.keys(this.__state).length === 0 || progressPercentage > 99 || !this.__proxyRef.isStandard) {
                return null;
            }
            var canCalculateProgress = !!this.__proxyRef.goalProgress.toAchieveCalculationValue && !!this.__proxyRef.calculationLabel && !this.program.isFinalResults;
            return {
                headerCode: 'progress.resultsToAchieveHeader',
                calculationLabel: this.__proxyRef.calculationLabel,
                canCalculateProgress: canCalculateProgress,
                goalLabelProps: tslib_1.__assign({}, this.__proxyRef.baseGoalLabel, { amount: this.__proxyRef.goalProgress.toAchieve || 0 }),
                calculationLabelProps: canCalculateProgress ? tslib_1.__assign({}, this.__proxyRef.baseGoalLabel, { amount: this.__proxyRef.goalProgress.toAchieveCalculationValue }) : null
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "minimumQualifier", {
        get: function () {
            if (!this.__proxyRef.hasMinimumQualifier) {
                return null;
            }
            return {
                headerCode: 'progress.minimumQualifierHeader',
                calculationLabel: '',
                canCalculateProgress: false,
                goalLabelProps: tslib_1.__assign({}, this.__proxyRef.minimumQualifierLabel, { amount: get_1.default(this.__proxyRef, 'goalSelection.minQualifier') || 0 }),
                calculationLabelProps: null
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "minimumQualifierProgress", {
        get: function () {
            if (!this.__proxyRef.hasMinimumQualifier) {
                return null;
            }
            return {
                headerCode: this.program.isFinalResults ? 'progress.finalMqProgressHeader' : 'progress.mqProgressHeader',
                calculationLabel: '',
                canCalculateProgress: false,
                goalLabelProps: tslib_1.__assign({}, this.__proxyRef.minimumQualifierLabel, { amount: this.__proxyRef.goalProgress.currentMQValue || 0 }),
                calculationLabelProps: null
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "bonusPayoutProgress", {
        get: function () {
            if (!this.__proxyRef.isBonusEnabled) {
                return null;
            }
            return {
                headerCode: '',
                calculationLabel: '',
                canCalculateProgress: false,
                goalLabelProps: tslib_1.__assign({}, this.bonusLabel, { amount: this.__proxyRef.goalProgress.currentBonusValue || 0 }),
                calculationLabelProps: null
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "goalDetails", {
        get: function () {
            var goalSelection = this.__proxyRef.goalSelection || {};
            return {
                hasSelectedGoal: Object.keys(goalSelection || {}).length > 0,
                description: goalSelection.description || '',
                name: goalSelection.name || '',
                goalAwardAmount: goalSelection.goalAwardAmount || 0,
                groupName: get_1.default(this.__state, 'goal.groupName') || '',
                goalSelectionHelpText1: get_1.default(this.__state, 'goal.goalSelectionHelpText1') || '',
                goalSelectionHelpText2: get_1.default(this.__state, 'goal.goalSelectionHelpText2') || '',
                goalSelectionQuestion: get_1.default(this.__state, 'goal.goalSelectionQuestion') || ''
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "progressStatusTreatment", {
        get: function () {
            return get_progress_status_treatment_1.default(this.__proxyRef.goalProgress.onTrackPercentage, this.program.programViewStatus, this.__proxyRef.goalProgress.progressPercentage, this.programCalculationType, this.__proxyRef.goalProgress.isMinQualifierAchieved);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "programResultType", {
        get: function () {
            if (this.program.isManager) {
                return 'manager';
            }
            return this.program.programType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "finalResultCode", {
        get: function () {
            if (!this.program) {
                return '';
            }
            switch (this.__proxyRef.programResultType) {
                case 'manager':
                    return resultCodes.forManager(this.program, this.__proxyRef);
                case constants.PT__GQ:
                    return resultCodes.forGoalquest(this.program, this.__proxyRef);
                case constants.PT__CP:
                    return resultCodes.forChallengepoint(this.program, this.__proxyRef);
                case constants.PT__OBJ:
                    return resultCodes.forObjective(this.program, this.__proxyRef);
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "finalStatus", {
        get: function () {
            if (!this.program.isFinalResults) {
                return null;
            }
            return {
                message: finalStatus.getResultMessageCode(this.__proxyRef.programResultType, this.finalResultCode),
                submessage: finalStatus.getResultSubmessageCode(this.__proxyRef.programResultType, this.finalResultCode),
                footer: finalStatus.getFooterMessageCode(this.__proxyRef.programResultType, this.finalResultCode)
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComputedProgress.prototype, "progressLastUpdated", {
        get: function () {
            return this.program.programHasStarted ? this.program.startDate : null;
        },
        enumerable: true,
        configurable: true
    });
    return ComputedProgress;
}());
var createProgressModel = function (program, progress) {
    var CACHE = {};
    var computedProgress = new ComputedProgress(program, progress);
    var computedProto = computedProgress.constructor.prototype;
    var progressModel = new Proxy(computedProgress.__state, {
        get: function (target, key) {
            if (key === '__state' || key === 'program') {
                return computedProgress[key];
            }
            else if (key in CACHE) {
                return CACHE[key];
            }
            CACHE[key] = key in computedProto ? computedProgress[key] : target[key];
            return CACHE[key];
        },
        set: function (target, key, value) {
            CACHE[key] = value;
            return true;
        }
    });
    computedProgress.__proxyRef = progressModel;
    return progressModel;
};
exports.default = createProgressModel;
//# sourceMappingURL=progress-model.js.map